// Pure sort/filter for the coach My Clients + admin Users list pages.
// Kept UI-agnostic so it is unit-testable and reusable across both pages.

const FILTERS = {
  all:         () => true,
  has_routine: (c) => !!c.routine_id,
  no_routine:  (c) => !c.routine_id,
  has_diet:    (c) => !!c.macros_customized,
  no_diet:     (c) => !c.macros_customized,
};

const COMPARATORS = {
  name:     (a, b) => (a.name || '').localeCompare(b.name || ''),
  calories: (a, b) => (a.target_calories || 0) - (b.target_calories || 0),
  added:    (a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0),
  routine:  (a, b) => (a.routine_id ? 1 : 0) - (b.routine_id ? 1 : 0),
};

export function applyClientSortFilter(clients, { sortBy = 'name', sortDir = 'asc', filter = 'all' } = {}) {
  const filterFn = FILTERS[filter] || FILTERS.all;
  const cmp = COMPARATORS[sortBy] || COMPARATORS.name;
  const out = clients.filter(filterFn);
  out.sort((a, b) => (sortDir === 'desc' ? -cmp(a, b) : cmp(a, b)));
  return out;
}
